export const NOT_NULL_MSG = "Can't be null";
export const MIN_MSG = "Must be greater {min}"

// todo(egor): create ErrorBuilder + export to separate lib + integrate with vuetify rules



// WEBPACK FOOTER //
// ./src/validation/messages.js